import { getFunctions } from "firebase/functions";
import firebaseApp from "./config";

const functions = getFunctions(firebaseApp, "europe-west3");

export default functions;
